<template>
   <svg width="14" height="7.999958" viewBox="0 0 14 7.999958" fill="none" version="1.1" id="svg1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
   <path d="M 1,0.99999988 6.9999995,6.999999 13,0.99999988" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /> 
</svg>

</template>